// extracted by mini-css-extract-plugin
export var emitationBox = "styles-module--emitation-box--9841b";
export var error = "styles-module--error--bd54c";
export var large = "styles-module--large--283b8";